import React from "react";
import { useLang } from "../i18n";

function Skills() {
  const { t } = useLang();

  return (
    <section id="skills" className="mt-20">
      <div className="section-label">
        <h2>{t.skills.heading}</h2>
        <span>stack.json</span>
      </div>
      <div>
        {t.skills.groups.map((group) => (
          <div key={group.name} className="skill-row">
            <h3 className="text-faint pt-1 font-mono text-[12px]">{group.name}</h3>
            <ul className="flex flex-wrap gap-2">
              {group.items.map((item) => (
                <li key={item} className="skill-chip">{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
